import { Injectable } from '@angular/core';

@Injectable()
export class OverlayContainer {
    protected containerElement: HTMLElement;

    public getContainerElement(): HTMLElement {
        if (!this.containerElement) {
            this._createContainer();
        }

        return this.containerElement;
    }

    protected _createContainer(): void {
        const container = document.createElement('div');
        container.classList.add('kdk-overlay-container');

        document.body.appendChild(container);

        this.containerElement = container;
    }
}
